/*
 * @Description: Tauri 环境下重写 window.open，使用 Tauri 窗口打开外部链接
 * @Date: 2026-04-24
 * @LastEditTime: 2026-04-24 13:17:04
 * @FilePath: \hui_ai_ui\src\utils\tauri-open-url.js
 */

import { invoke } from '@tauri-apps/api/core'

export function initTauriOpenUrl() {
  if (window.__TAURI__) {
    const nativeOpen = window.open

    window.open = function (url, target = '_blank') {
      if (target === '_blank' && (url.startsWith('http://') || url.startsWith('https://'))) {
        invoke('open_external_url', { url }).catch(console.error)
        return null
      }
      return nativeOpen?.call(this, url, target)
    }

    window._nativeOpen = nativeOpen

    document.addEventListener('click', function (e) {
      const link = e.target.closest('a')
      if (!link) return

      const href = link.getAttribute('href')
      if (!href) return

      const target = link.getAttribute('target')
      const isExternal = href.startsWith('http://') || href.startsWith('https://')

      if (isExternal && (target === '_blank' || !target)) {
        e.preventDefault()
        invoke('open_external_url', { url: href }).catch(console.error)
      }
    }, true)
  }
}
